import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  changesPanelBodyStyles,
  changesPanelHeaderStyles,
  changesPanelStyles,
} from '../../EntityAuditHistory.styles';
import { EntityAuditHistoryTestIds } from '../../EntityAuditHistory.testIds';

const AuditChangesPanel = ({ title, subtitle = null, children }) => (
  <Box data-testid={EntityAuditHistoryTestIds.CHANGES_PANEL} sx={changesPanelStyles}>
    <Box sx={changesPanelHeaderStyles}>
      <Typography data-testid={EntityAuditHistoryTestIds.CHANGES_PANEL_TITLE} variant="medium14">
        {title}
      </Typography>
      {subtitle}
    </Box>
    <Box sx={changesPanelBodyStyles}>{children}</Box>
  </Box>
);

AuditChangesPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
};

export default AuditChangesPanel;
